export default __webpack_public_path__ + "static/media/Karuna_Wielenga_th.70f4b5bd.png";